<template>
  <div class="evaluate">
    <a-card>
      <h1>课时</h1>
      <a-divider />
      <div class="box">
        <span>排序：{{ info.displayOrder }}</span>
        <span>课时名称：{{ info.name }}</span>
      </div>
    </a-card>
    <a-card style="margin: 30px 0">
      <h1>课程目标</h1>
      <a-divider />
      <div class="box" style="justify-content: space-between">
        <div class="target" v-for="item in info.objectives">
          <span>{{ item.objectiveName }}</span>
          <p>{{ item.objectiveContent }}</p>
        </div>
      </div>
    </a-card>
    <a-card v-for="(value, key) in getEvaluations" :title="(key == 1 ? '课前' : '课后') + '-' + value.stageName" :key="key" style="margin-bottom: 30px">
      <a-card>
        <h1>学习效果</h1>
        <a-divider />
        <div class="box">
          <span v-if="value.list.filter((f) => f.evaluationType == 1).length">知识测试：{{ value.list.filter((f) => f.evaluationType == 1).length ? value.list.filter((f) => f.evaluationType == 1)[0].questionGroupName : '--' }}</span>
          <span v-if="value.list.filter((f) => f.evaluationType == 2).length">情感态度：{{ value.list.filter((f) => f.evaluationType == 2).length ? value.list.filter((f) => f.evaluationType == 2)[0].questionGroupName : '--' }}</span>
        </div>
      </a-card>
      <a-card v-if="key==2" style="margin-top: 30px; margin-bottom: 100px">
        <h1>教师评价</h1>
        <a-divider />
        <div class="box">
          <span v-if="value.list.filter((f) => f.evaluationType == 3).length">教师评价：{{ value.list.filter((f) => f.evaluationType == 3).length ? value.list.filter((f) => f.evaluationType == 3)[0].questionGroupName : '--' }}</span>
        </div>
      </a-card>
    </a-card>
    <footer-tool-bar>
      <div class="btns">
        <a-button @click="backpage()">返回</a-button>
      </div>
    </footer-tool-bar>
  </div>
</template>

<script>
import FooterToolBar from '@/components/tool/FooterToolBar'
import $Bus from '@/pages/projectImpl/js/eventBus'

export default {
  name: 'EvaluateContent',
  components: { FooterToolBar },
  data() {
    return {
      value: '',
      info: {
        evaluations: [],
      },
    }
  },
  computed: {
    getEvaluations() {
      const result = {}
      this.info.evaluations.forEach((item) => {
        if (!result[item.stageType]) {
          result[item.stageType] = {
            stageName: item.stageName,
            list: [],
          }
        }
        result[item.stageType].list.push(item)
      })

      return result
    },
  },
  mounted() {
    this.getDetail()
    this.setTitle()
  },
  methods: {
    setTitle() {
      const arr = [
        '首页',
        '内容中心',
        { name: '课程管理', path: '/course/manage' },
        {
          name: '课时列表',
          path: '/course/manage/CourseChildren/CourseChildren?type=edit&name=课时列表',
        },
        '综合评价',
      ]
      $Bus.$emit('pageHeaderBreadcrumb', arr)
    },
    getDetail() {
      this.$http.CourseResource.courseSessionDetails(this.$route.query.id).then((res) => {
        this.info = res.data
      })
    },
    backpage() {
      // this.$router.push('/content/CourseSeting?type=edit&name=课时列表')
      this.$router.back()
    },
  },
}
</script>

<style scoped lang="less">
h1 {
  margin: 0;
  text-indent: 12px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-around;
  span {
    display: inline-block;
    width: 50%;
  }
}
// /deep/ .ant-input{
//     width: 32%;
// }
.target {
  width: 32%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 4px 11px;
  line-height: 1.5;
  vertical-align: bottom;
  transition: all 0.3s, height 0s;
  margin-bottom: 30px;
  min-height: 80px;
  span {
    margin-bottom: 5px;
  }
  p {
    margin: 0;
  }
}
</style>
